export const localStorageCluster = `${process.env.REACT_APP_LOCALSTORAGE_CLUSTER}`
export const apiUrl =`${process.env.REACT_APP_API_URL}`